module.exports = __webpack_public_path__ + "res/img_landing_3.7f1318d37161b4cc159f145ff2ca6559.webp";